export default __webpack_public_path__ + "static/new-revenue.url-261aad5f40dd22e2c73e2bdfe4a597f2.svg";